import './styles/playerwatermark.scss';
import React from 'react';

class PlayerWatermark extends React.Component {

  constructor(props) {
    super(props);
    const visibility = 'hidden';
    const top = props.imageData && props.imageData.position ? props.imageData.position.x + 'px' : '0px';
    const left = props.imageData && props.imageData.position ? props.imageData.position.y + 'px' : '0px';
    const width = props.imageData && props.imageData.size ? props.imageData.size.width + 'px' : '0px';
    const height = props.imageData && props.imageData.size ? props.imageData.size.height + 'px' : '0px';

    this.wrapperStyle = {
      visibility,
      top,
      left,
      width,
      height
    };
  }

  /**
   * Extra style defined in scss
   */
  render() {
    return (
      <div id="player_watermark_wrapper" className="player-watermark" style={this.wrapperStyle}>
        <img id="player_watermark_image" src={this.props.imageData && this.props.imageData.image} />
      </div>
    );
  }
}

export default PlayerWatermark;



// WEBPACK FOOTER //
// ./src/components/Video/PlayerWatermark.jsx